module.exports = __webpack_public_path__ + "img/meetingsclient20.fd1c83e5.png";